import Column from 'components/Column'
import Row from 'components/Row'
import Text from 'components/Text'
import React from 'react'
import styled from 'styled-components'

import { PropsType } from './index'

const Code = styled(Text)`
  padding: 0.5rem 0;
`

const BackupCodes = ({ tOtpConfig: { backupCodes } }: PropsType) => {
  return (
    <Column basis='auto' grow={1} justifyContent='center' shrink={1}>
      {backupCodes.map((code) => (
        <Row basis='auto' grow={1} justifyContent='center' key={code} shrink={1}>
          <Code color='black' size='lg' weight={600}>
            {code}
          </Code>
        </Row>
      ))}
    </Column>
  )
}

export default BackupCodes
